import { createSlice, type PayloadAction } from "@reduxjs/toolkit";
import { installationConfig } from "@/shared/constants/installation-config";
import type { I18nState, Language } from "./types";
import { LANGUAGE_KEY } from "./types";

const initialLang = localStorage.getItem(LANGUAGE_KEY) || installationConfig.defaultLang;
const initialState: I18nState = {
  selectedLang: initialLang as Language,
};

export const i18nSlice = createSlice({
  initialState,
  name: "i18n",
  reducers: {
    setSelectedLang: (state: I18nState, action: PayloadAction<Language>) => {
      state.selectedLang = action.payload;
    },
  },
});

export const { setSelectedLang } = i18nSlice.actions;
